export default () => {
  const container = document.querySelector('.real-estate-sort-form');
  
  if (!container) {
    return;
  }

  const listingNavigation = document.querySelector('.real-estate-navigation');

  if (listingNavigation) {
      const allNavElements = listingNavigation.querySelectorAll('.real-estate-purpose'),
            btns = container.querySelectorAll('.real-estate-purpose'),
            priceRange = document.querySelectorAll('fieldset[data-slug="priceFrom|priceTo"]'),
            defaultPriceLabel = container.querySelector('.real-estate-purpose-all');

    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        const data = btn.dataset;

        allNavElements.forEach(item => {
          item.classList.remove('active');
        });
  
        btn.classList.add('active');

        const priceLabel = data.pricelabel ? data.pricelabel : defaultPriceLabel.dataset.pricelabel;

        priceRange.forEach(priceRangeSingle => {
          const label = priceRangeSingle.querySelector('.filter-single-header-text');
          label.textContent = priceLabel;
        })
      });
    });
  }

  const returnToListBtns = document.querySelectorAll('.real-estate-full-map-prev-btn'),
        modalPosts = document.querySelectorAll('#real-estate-full-map .real-estate-posts a');

  if (returnToListBtns.length && modalPosts.length) {
    returnToListBtns.forEach(btn => {
      btn.addEventListener('click', () =>{
        modalPosts.forEach(post => {
          post.classList.remove('d-none');
        })
        btn.parentNode.classList.remove('d-flex');
        btn.parentNode.classList.add('d-none');
      })
    });
  }
};